import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, bootstrapped } = useAuth();
  if (!bootstrapped) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50" data-testid="loading-screen">
        <div className="font-mono text-xs uppercase tracking-widest text-zinc-500">Cornerstone</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
